import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaComments, FaWhatsapp, FaTimes } from 'react-icons/fa';

const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(55, 48, 163, 0.3);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 6px 15px rgba(55, 48, 163, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(55, 48, 163, 0.3);
  }
`;

const BubbleContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
  }

  @media (max-width: 480px) {
    bottom: 10px;
    right: 10px;
  }
`;

const ChatBubbleButton = styled.button`
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: ${props => props.open ? '#e42932' : '#3730A3'};
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  box-shadow: 0 4px 15px rgba(55, 48, 163, 0.3);
  transition: all 0.3s ease;
  animation: ${pulse} 2s ease-in-out infinite;
  
  &:hover {
    transform: scale(1.05);
    background: ${props => props.open ? '#dc2626' : '#0b0b77'};
    box-shadow: 0 6px 20px rgba(55, 48, 163, 0.4);
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
    font-size: 1.3rem;
  }
`;

const WhatsAppButton = styled.a`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #25D366;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-decoration: none;
  
  &:hover {
    transform: scale(1.05);
    background: #20b859;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 480px) {
    width: 42px;
    height: 42px;
    font-size: 1.2rem;
  }
`;

const ChatBubble = ({ open, onToggle, onWhatsApp }) => {
  return (
    <BubbleContainer>
      {!open && (
        <WhatsAppButton
          href="https://wa.me/9000013099?text=Hello%21%20I%27m%20interested%20in%20your%20courses"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          <FaWhatsapp />
        </WhatsAppButton>
      )}
      <ChatBubbleButton open={open} onClick={onToggle}>
        {open ? <FaTimes /> : <FaComments />}
      </ChatBubbleButton>
    </BubbleContainer>
  );
};

export default ChatBubble;